import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateClientRelatedQueries } from '@/modules/common/utils/query-invalidation';

import { deleteClients } from '../api/clients.api';

export const useDeleteClientsBulk = ({ onSuccess }: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.clients');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: deleteClients,
    onSuccess: async () => {
      // Invalidate all client related queries and their dependencies
      await invalidateClientRelatedQueries(queryClient);

      displayToastSuccess(t('toasts.clientsDeletedSuccess'));

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'toasts.deleteClientsError');
    },
  });
};
